import { render } from "./DialogConfirmComment.vue?vue&type=template&id=2cb48f58"
import script from "./DialogConfirmComment.vue?vue&type=script&lang=js"
export * from "./DialogConfirmComment.vue?vue&type=script&lang=js"

import "./DialogConfirmComment.vue?vue&type=style&index=0&id=2cb48f58&lang=scss"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__